module.exports = __webpack_public_path__ + "img/category-column.f0f1a2bf.svg";